import { render } from "./SoleilnoirAppPage.vue?vue&type=template&id=2bdf0be4"
import script from "./SoleilnoirAppPage.vue?vue&type=script&lang=js"
export * from "./SoleilnoirAppPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__